import { useTranslation } from "@redotech/redo-i18n";
import QrCode from "@redotech/redo-icons/qr-code-01.svg";
import { InteractiveMapLocation } from "@redotech/redo-model/draft-return/draft-return";
import { BlueYonderZod } from "@redotech/redo-model/return";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import {
  BlueYonderLocationsButton,
  BlueYonderLocationsSearchParams,
} from "./blue-yonder-locations-button";

export const BlueYonderQRCard = memo(function BlueYonderQRCard({
  blueYonderQRCodes,
  returnId,
  autoOpen = false,
  searchBlueYonderLocations,
  onOpenUrl,
}: {
  blueYonderQRCodes: BlueYonderZod["returns"];
  returnId: string;
  autoOpen?: boolean;
  searchBlueYonderLocations: (
    params: BlueYonderLocationsSearchParams,
  ) => Promise<InteractiveMapLocation[]>;
  onOpenUrl: (url: string) => void;
}) {
  const { t } = useTranslation();
  const qrCodeUri = blueYonderQRCodes[0]?.qrCodeUri;

  if (!blueYonderQRCodes.length) {
    return null;
  }

  return (
    <>
      <Flex>
        <RedoButton
          hierarchy="secondary"
          IconLeading={QrCode}
          onClick={() => qrCodeUri && onOpenUrl(qrCodeUri)}
          text={t("QR code")}
        />
      </Flex>
      <BlueYonderLocationsButton
        autoOpen={autoOpen}
        returnId={returnId}
        searchBlueYonderLocations={searchBlueYonderLocations}
      />
    </>
  );
});
